import React from 'react';


const CalendarSVG = ({ color = "#000" }) => {
  return (
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 8H16M6 5V1M14 5V1M3 3H17C18.1046 3 19 3.89543 19 5V19C19 20.1046 18.1046 21 17 21H3C1.89543 21 1 20.1046 1 19V5C1 3.89543 1.89543 3 3 3Z" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default CalendarSVG;
